import React, { useContext, useMemo, useState } from "react";
import LandingLayout from "./LandingLayoutRedesign";
import { ThemeContext } from "../../context/ThemeContext";
import AnimatedYieldCurveChart from "./AnimatedYieldCurveChartRedesign";
import StateGovernmentYieldChart from "./StateGovernmentYieldChartRedesign";
import CorporateYieldCurves from "./CorporateYieldCurvesRedesign";
import "./MarketInsightsRedesign.css";

const MARKETS = [
  { key: "gsec", label: "G-Sec", hint: "Sovereign benchmark" },
  { key: "sdl", label: "State DL", hint: "State vs Centre" },
  { key: "corp", label: "Corporate", hint: "Credit by rating" },
];

const MarketInsightsRedesign = () => {
  const { isDark } = useContext(ThemeContext);
  const [activeMarket, setActiveMarket] = useState("gsec");

  const activeMeta = useMemo(() => MARKETS.find((m) => m.key === activeMarket), [activeMarket]);

  return (
    <LandingLayout>
      <div className={`mi-page${isDark ? " mi-page--dark" : ""}`}>
        <div className="mi-page-inner">
          <header className="mi-toolbar">
            <div className="mi-toolbar__primary">
              <div className="mi-view-tabs" role="tablist" aria-label="Market segments">
                {MARKETS.map((market) => (
                  <button
                    key={market.key}
                    type="button"
                    role="tab"
                    aria-selected={activeMarket === market.key}
                    className={`mi-view-tab${
                      activeMarket === market.key ? " mi-view-tab--active" : ""
                    }`}
                    onClick={() => setActiveMarket(market.key)}
                  >
                    {market.label}
                  </button>
                ))}
              </div>
              <p className="mi-toolbar__meta">
                <strong>{activeMeta?.label}</strong>
                <span>{` · ${activeMeta?.hint}`}</span>
              </p>
            </div>
          </header>

          <section className="mi-panel" aria-label={`${activeMeta?.label} yield view`}>
            {activeMarket === "gsec" && <AnimatedYieldCurveChart />}
            {activeMarket === "sdl" && <StateGovernmentYieldChart />}
            {activeMarket === "corp" && <CorporateYieldCurves />}
          </section>
        </div>
      </div>
    </LandingLayout>
  );
};

export default MarketInsightsRedesign;
